import React, {Component} from 'react';
import SimpleSelect from 'components/atoms/dropdowns/simple-select';
import Const from 'constants';

class SelectStackType extends Component {
    getOptions() {
        return {
            [Const.STACKS_TYPE_AT_LEAST]: 'No less than',
            [Const.STACKS_TYPE_EXACTLY]: 'Exactly',
            [Const.STACKS_TYPE_AT_MOST]: 'No more than',
        };
    }
    render() {
        const {className} = this.props;

        return (
            <SimpleSelect
                className={className}
                value={this.props.value}
                options={this.getOptions()}
                onChange={this.props.onChange}
            />
        );
    }
}

export default SelectStackType;
